import React from "react";
import RecordEdit from "../../components/RecordEdit";

export default function PublisherAccountEdit() {
    const urlParams = new URLSearchParams(window.location.search);
    const values = Object.fromEntries(urlParams.entries());

    return (
        <RecordEdit
            values={values}
            title="Edit Customer Account"
            table_name="clients_accounts"
            breadcrumb="Account"
            redirect="/pub/customers/accounts"
            item_name="Account"
        />
    )
}